import styled from "styled-components";

const DrawerWrapper = styled.div`
  .drawer-container:nth-child(4) {
    color: red;
  }
`;

export { DrawerWrapper };
